import React from 'react';
import Layout from '../Layout';
import { HeaderSection, StatContainer } from './AccountComponent';
import { ExpenseCard1, ExpenseCard2, MaintenanceCard1, MaintenanceCard2, OrderCard1, OrderCard2 } from './CardComponent';
// import './AccountStatistic.css';


export function AccountStatistic() 
{

  return (

    <Layout activeMenu={4}>
  
      <div className='container-fluid'>
        <div className='row justify-content-center pt-4'>
          <div className='col-md-11'>
                
            <div className='row' >
              <HeaderSection active={1} />
            </div>

            {/* Cartes de Statistiques */}
            <StatContainer />

            {/* SECTION 1: Commandes de Ventes */}
            <div className='row statistics-section mb-5'>
              <div className='col-12 px-0'>

                <div className="section-header mb-4 bg-lightColor1 p-3 rounded">
                  <div className="section-icon sales">
                    <i className="bi bi-bag-check fs-3"></i>
                  </div>
                  <div>
                    <h4 className="text-muted">Commandes de Ventes</h4>
                    <p className="text-muted">Analyse des revenus générés par les commandes livrées</p>
                  </div>
                </div>

                {/* Graphe Mensuel */}
                <OrderCard1 />
                {/* Graphe Annuel */}
                <OrderCard2 />
                
              
              </div>
            </div>

            {/* SECTION 2: Installations et Maintenances */}
            <div className='row statistics-section mb-5'>
              <div className='col-12 px-0'>

                <div className="section-header mb-4 bg-lightColor2 p-3 rounded">
                  <div className="section-icon maintenance">
                    <i className="bi bi-tools fs-4"></i>
                  </div>
                  <div>
                    <h4 className="text-muted">Installations et Maintenances</h4>
                    <p className="text-muted">Analyse des revenus générés par les installations et maintenances</p>
                  </div>
                </div>

                {/* Graphe Mensuel */}
                <MaintenanceCard1 />
                {/* Graphe Annuel */}
                <MaintenanceCard2 />

              </div>
            </div>

            {/* SECTION 3: Dépenses */}
            <div className='row statistics-section mb-5'>
              <div className='col-12 px-0'>
                <div className="section-header mb-4 bg-lightColor3 p-3 rounded">
                  <div className="section-icon expenses">
                    <i className="bi bi-cash-stack fs-4"></i>
                  </div>
                  <div>
                    <h4 className="text-muted">Dépenses</h4>
                    <p className="text-muted">Analyse des dépenses engagées par mois et par an</p>
                  </div>
                </div>

                {/* Graphe Mensuel */}
                <ExpenseCard1 />
                {/* Graphe Annuel */}
                <ExpenseCard2 />
                
              </div>
            </div>

          </div>   
        </div>
      </div>

    </Layout>

  );
        
}